<template>
  <!-- 填报步骤 -->
  <div class="fillStep">
    <div class="title f-r j-b">
      <span>上云填报</span>
      <div>
        <span class="back" @click="back('0')">上云填报记录</span>
        <span class="back" @click="back('1')">填报申请记录</span>
        <span class="back" @click="back('2')">上云评分</span>
      </div>
    </div>
    <div class="container">
      <el-steps :active="activeStep" align-center>
        <el-step
          :description="item.label"
          v-for="(item, index) in stepsList"
          :key="index"
          @click.native="onClickStep(index)"
        >
          <div slot="icon">
            <div :class="(index < activeStep - 1) ? 'stepCur' : ''">{{ index + 1 }}</div>
          </div>
        </el-step>
      </el-steps>
      <!-- 企业上云填报步骤条 -->
      <div class="steps">
        <firstStep v-show="activeStep == 1" ref="firstStep" :ifEdit="ifEdit" />
        <secondStep
          v-show="activeStep == 2"
          ref="secondStep"
          :registerId="registerId"
          :ifEdit="ifEdit"
        />
        <thirdStep
          v-show="activeStep == 3"
          ref="thirdStep"
          :registerId="registerId"
          :ifEdit="ifEdit"
        />
        <fourthStep
          v-show="activeStep == 4"
          ref="fourthStep"
          :registerId="registerId"
          :ifEdit="ifEdit"
          :typeFlag="typeFlag"
        />
        <div class="btnGroup f-r j-c a-c">
          <div v-show="activeStep > 1" class="form-pre" @click="activeStep--">上一步</div>
          <div v-show="activeStep < 4" class="form-next" @click="save">下一步</div>
          <div v-show="activeStep == 4 && ifEdit" class="form-next" @click="submit">提交</div>
          <div v-show="activeStep == 4 && ifEdit" class="form-pre" @click="save">保存</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firstStep from "./component/firstStep.vue";
import secondStep from "./component/secondStep.vue";
import thirdStep from "./component/thirdStep.vue";
import fourthStep from "./component/fourthStep.vue";
export default {
  name: "",
  components: { firstStep, secondStep, thirdStep, fourthStep },
  props: {},
  data() {
    return {
      activeStep: 1,
      stepsList: [
        { label: "企业基础信息登记" },
        { label: "基础设施上云情况" },
        { label: "管理系统上云情况" },
        { label: "业务应用上云情况" }
      ],
      typeFlag: "", // 所在产业
      registerId: "", // 第一步产生的registerId 给后面三步使用
      ifEdit: false // 是否是可编辑状态，即上云申请只保存未提交 false为不可编辑，只能查看详情；true为可以编辑。
    };
  },
  watch: {},
  computed: {},
  created() {},
  mounted() {
    if (this.$route.query.uuid) {
      // 详情或编辑
      this.ifEdit = this.$route.query.type == "edit" ? true : false;
    } else {
       // 新增
      this.ifEdit = true;
    }
  },
  methods: {
    /* 下一步保存 */
    save() {
      if (this.$route.query.type == "detail") {
        // 如果当前是查看详情的状态
        this.activeStep++;
      } else if (this.$route.query.type == "edit" || !this.$route.query.uuid) {
        switch (this.activeStep) {
          case 1:
            this.$refs.firstStep.save();
            break;
          case 2:
            this.$refs.secondStep.save();
            break;
          case 3:
            this.$refs.thirdStep.save();
            break;
          case 4:
            this.$refs.fourthStep.save('save');
            break;
        }
      }
    },
    /* 提交 */
    submit() {
      this.$refs.fourthStep.submit();
    },
    /* 获得所在产业 */
    getTypeFlag(val) {
      this.typeFlag = val;
    },
    getRegisterId(registerId) {
      this.registerId = registerId;
    },
    back(code) {
      this.$router.push({
        path: "/cloudUp",
        query: {
          code
        }
      });
    },
    onClickStep(index) {}
  }
};
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";
.fillStep {
  position: relative;
  background-color: #f4f4f4;
  padding: 0px 0 20px 0;
  overflow: hidden;
  .title {
    color: @basic-colors;
    width: 1300px;
    margin: 10px auto 10px;
    padding-left: 30px;
    font-size: 18px;
    font-weight: bold;
    position: relative;

    &::before {
      position: absolute;
      content: "";
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background-color: @basic-colors;
      left: 15px;
      top: 50%;
      transform: translateY(-50%);
    }

    .back {
      margin-right: 14px;
      cursor: pointer;
    }
  }
  .container {
    width: 1300px;
    min-height: 400px;
    background-color: #ffff;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: 20px;
    margin: 0 auto;
    .stepCur {
      width: 36px;
      height: 36px;
      line-height: 36px;
      border-radius: 50%;
      color: #fff;
      background-color: @basic-colors;
    }

    .steps {
      margin-top: 20px;
      width: 100%;
      min-height: 400px;
      // .bd();
      padding: 20px 300px;
      .bs();

      .btnGroup {
        margin: 40px auto 20px;

        .form-next,
        .form-pre,
        .form-save {
          width: 120px;
          height: 40px;
          .lh(40px);
          .bs();
          .bc();
          .br(4px);
          text-align: center;
          color: #fff;
          cursor: pointer;
          margin: 0 5px;
        }

        .form-pre {
          color: @basic-colors;
          border: 1px solid #2d50a1;
          .bc(15%);
        }

        .form-save {
          background-color: #909399;
          border-color: #909399;
        }
      }
    }
    /* 步骤条样式 */
    /deep/ .el-step__icon.is-text.is-finish {
      border: 2px solid @basic-colors;
    }

    /deep/ .el-step__head.is-finish {
      border-color: @basic-colors;
    }

    /deep/ .el-step__title {
      font-size: 16px;
      line-height: 38px;
      position: absolute;
      left: 50%;
      -webkit-transform: translateX(-50%);
      -ms-transform: translateX(-50%);
      transform: translateX(-50%);
      top: -60px;
    }

    /deep/ .el-step.is-center .el-step__description {
      margin-top: 10px;
      font-size: 16px;
      font-weight: bold;
      color: @basic-colors;
    }

    /deep/ .el-step__icon {
      width: 36px;
      height: 36px;
      color: @basic-colors;
    }

    /deep/ .el-step.is-horizontal .el-step__line {
      top: 18px;
    }

    /deep/ .is-process{
      color: #c0c4cc;
      border-color: #c0c4cc;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/enterpriseCloudUp/fillStep.vue